<mds-datepicker
    [formCtrl]="formControl"
    [appearance]="'outline'"
    [placeholder]="'Select date'"
    [min]="customParams().min"
    [max]="customParams().max"
/>
